import { createAction, props } from '@ngrx/store';

export const taskAll = createAction('TASK_ALL', props<{items: any}>());
export const taskList = createAction('TASK_LIST', props<{items: any}>());
export const taskCreate = createAction('TASK_CREATE', props<{item: any}>());
export const taskUpdate = createAction('TASK_UPDATE', props<{item: any}>());
export const taskDelete = createAction('TASK_DELETE', props<{item: any}>());
